import React from 'react';

const PaymentMethodsList = ({
  selectedPaymentMethods,
  keyPrefix = 'list',
  ulClassName = 'tw-pl-7 tw-mb-1',
  liClassName = '',
  linkClassName = 'tw-text-blue-500'
}) => {
  return (
    <ul className={ulClassName}>
      {selectedPaymentMethods.map((m) => (
        <li key={`${keyPrefix}-${m.key}`} className={liClassName}>
          {m.name}
          {': '}
          <span className={linkClassName}>{m.link}</span>
        </li>
      ))}
    </ul>
  );
};

export default PaymentMethodsList;
